module.exports = __webpack_public_path__ + "static/media/en-cancel-service_3.788e6fcb.png";